import Swiper from 'swiper';
import AOS from 'aos';
import Cookies from 'js-cookie';

export default {
  init() {

    /* Animate on Scroll
    ---------------------------------------------------------------------------------------------------- */
    
    AOS.init();


    /* Parallax
    ---------------------------------------------------------------------------------------------------- */

    $('.illustration').paroller();
    

    /* Scrolling
    ---------------------------------------------------------------------------------------------------- */

    $(window).on('scroll mousewheel', function() {
      
      var topScrollThreshold = 100;
      
      if($(window).scrollTop() < topScrollThreshold) {
        $('html').removeClass('scrolled').addClass('top');
      } else {
        $('html').removeClass('top').addClass('scrolled');
      }
      
      $(window).trigger('resize');
      
    }).trigger('scroll');
    
/*
    setTimeout(function() {
      console.log('update');
      $(window).trigger('resize').trigger('scroll').trigger('resize');
    }, 2000);
*/

    
    
    /* Register Popup
    ---------------------------------------------------------------------------------------------------- */
    
    $('#main').on('initMain', function(){
      
      var el = $(this), 
          popupID     = $(el).data('popup-id'), 
          popupExpiry = parseInt($(el).data('popup-expiry')), 
          popupTimer  = parseInt($(el).data('popup-timer')) * 1000;

      if (typeof popupID === 'undefined' || !popupID.length) {
        popupID = 'register-now-modal';
      }
      
      if(typeof popupTimer === 'undefined' || !popupTimer) {
        popupTimer = 3000;
      }
      
      if(typeof popupExpiry === 'undefined' || !popupExpiry) {
        popupExpiry = 7;
      }
      
      if($('body').hasClass('is-home')) {
        setTimeout(function() {
  
          if(!Cookies.get(popupID)) {
            Cookies.set(popupID, '1', { expires: popupExpiry });
            $(el).trigger('openRegisterModal');
          }
          
        }, popupTimer); 
      }
        
        
      
      //$('.open-modal, a[href$="#register"').click(function(e){
      $('.open-modal').click(function(e){
        e.preventDefault();
        $(el).trigger('openRegisterModal', $(this).attr('href'));
      });
      
      
    }).on('openRegisterModal', function(e, dataSource){
      
      if (typeof dataSource === 'undefined') {
        dataSource = $('.register-now').first().attr('href');
      }
      
      if (typeof dataSource === 'undefined' || !dataSource.length) {
        return;
      }
      
      $.magnificPopup.open({
        items: {
          src: dataSource,
        },
        type: 'ajax',
        tLoading: '',
        removalDelay: 500,
        closeBtnInside: false,
        callbacks: {
          parseAjax: function(mfpResponse) {
            mfpResponse.data = $(mfpResponse.data).find('#main .contact-form');
          },
          beforeOpen: function() {
            //$(this).addClass('mfp-zoom-in');
            this.st.mainClass = 'mfp-zoom-in';
          },
          ajaxContentAdded: function() {
      
            // Select Box
            
            $('select.input-select').customSelect();
            
            // Radio / Checkbox
            
            $('.input-radio, .input-checkbox').iCheck().on('ifChanged', function (event) { 
                
                $(event.target).trigger('change');
                
            }).on('ifChecked ifUnchecked', function(event){
                $(event.target).trigger('change');
              
            }).on('change', function(){
        
              var iCheckEl = $(this).closest('.radio-wrapper, .checkbox-wrapper');
                  $(iCheckEl).trigger('updateRadioView');
              
            });
            
            $('.close-modal').click(function(e){
              e.preventDefault();
              $.magnificPopup.instance.close(); 
            });
            
          },
        },
      });
      
    }).trigger('initMain');
    

    
    
    /* Nav
    ---------------------------------------------------------------------------------------------------- */

    $('#nav-mobile').on('initNav', function(){
      
      var el = $(this);
      
      $('.toggle-menu').click(function(e){
        e.preventDefault();
        
        if($('body').hasClass('showing-menu')) {
          $(el).trigger('closeMenu');
        } else {
          $(el).trigger('openMenu');
        }
        
      });

      $('.open-menu').click(function(e){
        e.preventDefault();
        $(el).trigger('openMenu');
      });
      
      $('.overlay, .close-menu', el).click(function(e){
        e.preventDefault();
        $(el).trigger('closeMenu');
      });
      
      $('a', el).click(function(e){
        e.stopPropagation();
        
        $(el).trigger('closeMenu');
      });
      
    }).on('openMenu', function(){
      
      if($('body').hasClass('hiding-menu')) {
        return;
      }
      
      $('body').addClass('showing-menu').addClass('will-show-menu');

      setTimeout(function() {
        $('body').addClass('finished-showing-menu').removeClass('will-show-menu');
      }, 300);
      
    }).on('closeMenu', function(){
      
      $('body').removeClass('finished-showing-menu').removeClass('showing-menu').addClass('hiding-menu').removeClass('will-show-menu');
      
      setTimeout(function() {
        $('body').removeClass('hiding-menu');
        
        // Closing any open sub menus
        $('.menu-item-has-children-link').trigger('closeSubMenu');
        
      }, 500);
      
    }).trigger('initNav');
    
    
    
    /* Forms
    ---------------------------------------------------------------------------------------------------- */
    
    // Select Box
    
    $('select.input-select').customSelect();
    
    // Radio / Checkbox
    
    $('.input-radio, .input-checkbox').iCheck().on('ifChanged', function (event) { 
        
        $(event.target).trigger('change');
        
    }).on('ifChecked ifUnchecked', function(event){
        $(event.target).trigger('change');
      
    }).on('change', function(){

      var iCheckEl = $(this).closest('.radio-wrapper, .checkbox-wrapper');
          $(iCheckEl).trigger('updateRadioView');
      
    });
    
    $('.radio-wrapper, .checkbox-wrapper').on('updateRadioView', function(){

      var el = $(this), 
          inputEl = $('.input-radio, .input-checkbox', this);

        if ($(inputEl).is(':checked')) {

          $(el).addClass('is-checked');
          $(inputEl).trigger('checked');
                    
        } else {
          $(el).removeClass('is-checked');
        }
  
          
    }).trigger('updateRadioView');
    
    

    /* Permalinks
    ---------------------------------------------------------------------------------------------------- */
    
    $('*[data-permalink]').unbind().click(function(e){

      e.preventDefault();
      e.stopPropagation();
      
      var el = $(this), 
          permalink = $(el).data('permalink'), 
          target    = $(el).data('permalink-target'), 
          windowFeatures = ''; 
          
          if (typeof target !== 'undefined' && target == '_blank') {
            window.open(permalink, '_blank', windowFeatures);
            return;
          }
          
          $(el).addClass('loading-permalink');
          
          window.location.href = permalink;
      
    });
    
    
    /* Accordion Content
    ---------------------------------------------------------------------------------------------------- */

    $('.accordion-content').on('initAccordion', function(){
      
      var el = $(this);
      
      if((window.location.hash.length > 1) && $(window.location.hash, el).length) {

        setTimeout(function() {
            
          var itemEl = $(window.location.hash, el).closest('.item');
          $(itemEl).trigger('openItem');
          
          //var offset = -($('#header').height());
          //$(window).scrollTo($(itemEl), 500, {offset:offset});
            
        }, 500);
        
      }
      
  
    }).trigger('initAccordion');
    
    
    
    $('.accordion-content .item').on('initAccordionItem', function(){

      var el = $(this);
      
      $('.trigger-toggle-accordion-item', el).click(function(e){
        e.preventDefault();
        $(el).trigger('toggleItem');
      });
  
    }).on('toggleItem', function(e) { // eslint-disable-line no-unused-vars
      
      var el = $(this), 
          isOpen = $(el).hasClass('open');
  
          if(isOpen) {
            $(el).trigger('closeItem');
          } else {
            $(el).trigger('openItem');
          }
      
    }).on('openItem', function(e) { // eslint-disable-line no-unused-vars
      
      var el = $(this), 
          containerEl   = $('.item-content', el), 
          contentEl      = $('.inner', containerEl), 
          openHeight = $(contentEl).height();
          
          $(el).addClass('opening');
          $(containerEl).clearQueue().animate({height: openHeight }, 250, function() {
            $(el).addClass('open').removeClass('opening');
            
            var offset = -($('#header').height() + 60);  
            $(window).scrollTo($(el), 350, {offset:offset});
            
          });
          
          $('.accordion-content .item').not(el).trigger('closeItem');
          
          
    }).on('closeItem', function(e) { // eslint-disable-line no-unused-vars
      
      var el = $(this), 
          containerEl   = $('.item-content', el), 
          closeHeight   = 0;
          
        $(el).addClass('closing').removeClass('open');
        $(containerEl).clearQueue().animate({height: closeHeight }, 250, function() {
          $(el).removeClass('open').removeClass('closing')
        });
      
    }).trigger('initAccordionItem');
    

  },
  
  
  
  finalize() {

  /* Slider
  ---------------------------------------------------------------------------------------------------- */

  $('.image-slider').on('initSlider', function(){

    var el = $(this), 
        sliderEl = new Swiper($(el), {
            pagination: {
              el: $('.swiper-pagination', el),
              type: 'bullets',
              clickable: true,
            },
            autoplay: {
              delay: 5000,
            },
            slidesPerView: 1,
            spaceBetween: 0, 
            runCallbacksOnInit: true,
        });
    
    
    sliderEl.on('slideChangeStart', function(swiper){
      
      if(swiper.isBeginning) {
        $(el).addClass('is-beginning');
      } else {
        $(el).removeClass('is-beginning');
      }
      
      if(swiper.isEnd) {
        $(el).addClass('is-end');
      } else {
        $(el).removeClass('is-end');
      }
      
    });
    

  }); //.trigger('initSlider');
  
  
    setTimeout(function() {
      $('.image-slider').trigger('initSlider');
    }, 500);

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js